let colorModalSwiper;

const colorModalInitSwiper = () => {
  colorModalSwiper = new Swiper('.color-selector-modal__content', {
    slidesPerView: 1,
    navigation: {
      nextEl: '.color-selector-modal__next',
      prevEl: '.color-selector-modal__prev',
    },
  });
};

const colorModalCheckSwiper = () => {
  const screenWidth = window.innerWidth;
  if (screenWidth <= 749 && !colorModalSwiper) {
    // 749px以下でSwiperが未初期化の場合、Swiperを初期化
    document.querySelector('.color-selector-modal__content').classList.add('swiper');
    document.querySelector('.color-selector-modal__container').classList.add('swiper-wrapper');
    colorModalInitSwiper();
  } else if (screenWidth > 749 && colorModalSwiper) {
    // 749px以上でSwiperが初期化されている場合、Swiperを破棄
    colorModalSwiper.destroy();
    colorModalSwiper = null;
    document.querySelector('.swiper-container').classList.remove('swiper-container');
    document.querySelector('.swiper-wrapper').classList.remove('swiper-wrapper');
  }
};

window.addEventListener('DOMContentLoaded', () => {
  // モーダル表示・非表示
  const colorModal = document.querySelector('.color-selector-modal');
  const colorModalTriggers = document.querySelectorAll(
    '.color-selector-modal__overlay, .color-selector-modal__close, .color-selector__item__img'
  );

  colorModalTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const imageIndex = trigger.dataset.index;
      console.log('imageIndex');
      if (imageIndex && colorModalSwiper) {
        colorModalSwiper.slideTo(imageIndex);
      }
      if (colorModal.classList.contains('is-show')) {
        colorModal.animate([{ opacity: '1' }, { opacity: '0' }], {
          duration: 500,
          easing: 'ease-in-out',
          fill: 'forwards',
        }).onfinish = () => {
          colorModal.style.display = 'none';
          colorModal.classList.toggle('is-show');
        };
      } else {
        colorModal.style.opacity = 0;
        colorModal.style.display = 'flex';
        colorModal.classList.toggle('is-show');
        colorModal.animate([{ opacity: '0' }, { opacity: '1' }], {
          duration: 500,
          easing: 'ease-in-out',
          fill: 'forwards',
        });
      }
    });
  });

  // Swiperの初期化
  colorModalCheckSwiper();
});

// リサイズ時にSwiperの初期化をチェック
window.addEventListener('resize', colorModalCheckSwiper);
